(function() {
    $.cookie.json = true;
    $.fn.idle.Constructor.DEFAULTS.events = 'mousemove.idle keydown.idle mousedown.idle touchstart.idle';

    //fix for "Does not use passive listeners to improve scrolling performance" message in PageInsights https://web.dev/uses-passive-event-listeners/?utm_source=lighthouse&utm_medium=devtools
    var $eventSpecial = $.event.special;

    $eventSpecial.touchstart = {
        setup: function( _, ns, handle ) {
            this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
        }
    };
    $eventSpecial.touchmove = {
        setup: function( _, ns, handle ) {
            this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
        }
    };
    $eventSpecial.wheel = {
        setup: function( _, ns, handle ){
            this.addEventListener('wheel', handle, { passive: true });
        }
    };
    $eventSpecial.mousewheel = {
        setup: function( _, ns, handle ){
            this.addEventListener('mousewheel', handle, { passive: true });
        }
    };

    var $focus = $.fn.focus;
    $.fn.focus = function(allowTouch) {
        //don't allow triggering of focus events for touch devices
        if(!allowTouch && fp.device.hasTouch && !fp.device.usingMouse) return this;

        var $input = this.filter('input,textarea').first(),
            input = $input[0];
        if(input && input == document.activeElement) {
            return this;
        }

        var returnValue = $focus.call(this);

        try {
            //set cursor to end of value
            input.selectionStart = input.selectionEnd = S.getString($input.val()).length;
        }
        catch(exc){}

        return returnValue;
    };

    $.fn.focusable = function(includeSelf) {
        const focasable = [];
        this.each(function() {
            let $elements = $(this).find('*');
            if(includeSelf) {
                $elements = $elements.addBack();
            }
            $elements.each(function() {
                const nodeName = this.nodeName.toLowerCase(),
                    $this = $(this),
                    hasTabindex = $this.attr('tabIndex') != null;
                    
                let map, mapName, img, focusableIfVisible, fieldset;
            
                if ('area' === nodeName) {
                    map = this.parentNode;
                    mapName = map.name;
                    if ( !this.href || !mapName || map.nodeName.toLowerCase() !== 'map' ) {
                        return;
                    }
                    img = $(`img[usemap="#${mapName}"]`);
                    if(img.length > 0 && img.is(':visible')) {
                        focasable.push(this);
                        return;
                    }
                }
            
                if (/^(input|select|textarea|button|object)$/.test(nodeName)) {
                    focusableIfVisible = !this.disabled;
            
                    if (focusableIfVisible) {
                        // Form controls within a disabled fieldset are disabled.
                        // However, controls within the fieldset's legend do not get disabled.
                        // Since controls generally aren't placed inside legends, we skip
                        // this portion of the check.
                        fieldset = $this.closest( 'fieldset' )[ 0 ];
                        if (fieldset) {
                            focusableIfVisible = !fieldset.disabled;
                        }
                    }
                }
                else if ('a' === nodeName) {
                    focusableIfVisible = this.href || hasTabindex;
                }
                else {
                    focusableIfVisible = hasTabindex;
                }

                if(focusableIfVisible && $this.is( ':visible' ) && $this.css( 'visibility' ) === 'visible') {
                    focasable.push(this);
                }
            });
        });
        return $(focasable);
    };
    
    var $detach = $.fn.detach;
    $.fn.detach = function(selector, enableAttach) {
        if(enableAttach) {
            this.each(function() {
                var parent = this.parentNode;
                if(parent) {
                    var $child = $('<span style="display:none !important;"></span>');
                    parent.replaceChild($child[0], this);
                    $(this).data('attach', $child)
                }
            });
        }
        return $detach.call(this, selector);
    };

    $.fn.attach = function() {
        return this.each(function() {
            var $attach = $(this).data('attach');
            if ($attach) $attach.replaceWith(this);
        });
    };

	$.fn.outerHTML = function() {
        var el = this[0];
        if(el && el.outerHTML) return el.outerHTML;
		var $p = $('<p>').append(this.eq(0).clone())
            ,html = $p.html();
        $p.remove();
        return html;
	};

    $.fn.center = function () {
        var $window = $(window);
        return this.each(function() {
            var $this = $(this);
            $this.css({
                position: 'absolute',
                top: ($window.height() - $this.height() ) / 2 + $window.scrollTop() + 'px',
                left: ($window.width() - $this.width() ) / 2 + $window.scrollLeft() + 'px'
            });
        });
    };

    //$.fn.matchHeight = function() {
    //    return this;
    //};
    //$.fn.matchHeight._update = $.noop;

    $.fn.getBoundingClientRect = function() {

        var el = this[0],
            doc = el && el.ownerDocument,
            rect = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: 0,
                height: 0
            };

        if (!doc) return rect;
        // Make sure it's not a disconnected DOM node
        if (!$.contains(doc.documentElement, el)) return rect;

        if (_.isFunction(el.getBoundingClientRect)) $.extend(rect, el.getBoundingClientRect());

        return rect;
    };

    $.fn.reflow = $.fn.redraw = function() {
        return this.each(function() {
            this.offsetHeight;
        });
    };

    $.fn.repaint = function() {
        return this.each(function() {
            var $this = $(this).css('visibility', 'hidden');
            $this.css('visibility', '');
        });
    };

    $.fn.scrollTo = function(selector, options) {
        options = _.isObject(options) ? options : {axis: options};
        return this.each(function() {
            var $this = $(this),
                $item = _.isString(selector) ? $this.find(selector) : selector;

            if($item.length) {
                if(options.axis === 'x') {
                    var left = $item.position().left - $item.outerWidth() * 0.5 + $this.scrollLeft();
                    // var left = $item.position().left - $item.outerWidth() * 0.5;
                    if(options.speed) $this.animate({'scrollLeft': left}, options.speed);
                    else $this.scrollLeft(left);
                }
                else {
                    var top = $item.position().top - $item.outerHeight() * 0.5 + $this.scrollTop();
                    if(options.speed) $this.animate({'scrollTop': top}, options.speed);
                    else $this.scrollTop(top);
                }
            }
        });
    };

    var $modal = $.fn.modal;
    $.fn.modal = function(option, relatedTarget) {
        if(!this.data('bs.modal')) {
            if (fpUtil.isNull(option) || _.isObject(option)) {
                option = $.extend({
                    container: fp.__$freshop.find('[data-role="modal-container"]'),
                    persist: true
                }, option);

                const $self = this;
                $self.__id = _.uniqueId();
                $self
                    .off('beforeshown.bs.modal.core show.bs.modal.core shown.bs.modal.core hide.bs.modal.core hidden.bs.modal.core click.closeModal.core')
                    .on('beforeshown.bs.modal.core', function (event) {
                        $(this).data('bs.modal').activeElement = document.activeElement;
                    })
                    .on('show.bs.modal.core', function (event) {
                        if(!event.isDefaultPrevented()) {
                            var $body = $(document.body),
                                scrollbarWidth = $.scrollbarWidth();

                            if(scrollbarWidth) {
                                $body.css('padding-right', scrollbarWidth + 'px');
                            }

                            $body.addClass('fp-modal-open');

                            fpUi.pauseLoading();
                        }
                    })
                    .on('shown.bs.modal.core', function () {
                        var $this = $(this),
                            bsModal = $this.data('bs.modal');

                        if(bsModal && bsModal.isShown) {
                            var labelledBy = $this.attr('aria-labelledby');
                            if(!labelledBy) {
                                var $title = $this.find('.modal-header').find('h3, h4, h5').first(),
                                    titleId = $title.attr('id');
                                if(!titleId) {
                                    titleId = 'fp-modal-title-' + _.uniqueId();
                                    $title.attr('id', titleId);
                                }
                                $this.attr('aria-labelledby', titleId);
                            }

                            if(option.disableClose) $this.find('.modal-header [data-dismiss="modal"]').addClass('invisible');
                            bsModal.focus();

                            const keydownEventName = `keydown.bs.modal.${$self.__id}`;
                            $(document)
                                .off(keydownEventName)
                                .on(keydownEventName, function(event) {
                                    if (event.keyCode === fpConstants.keycode.TAB) {
                                        const $focusElement = $self.focusable(),
                                            firstFocusableElement = $focusElement[0],
                                            lastFocusableElement = $focusElement.last()[0];
                                        if (event.shiftKey) { // Shift + Tab
                                            if (document.activeElement === firstFocusableElement) {
                                                event.preventDefault();
                                                lastFocusableElement.focus();
                                            }
                                        }
                                        else { // Tab
                                            if (document.activeElement === lastFocusableElement) {
                                                event.preventDefault();
                                                firstFocusableElement.focus();
                                            }
                                        }
                                    }
                                });
                        }
                    })
                    .on('hide.bs.modal.core', function () {
                        if($.contains(this, document.activeElement)) {
                            $(document.activeElement).trigger('blur');
                        }
                    })
                    .on('hidden.bs.modal.core', function () {
                        $(document).off(`keydown.bs.modal.${$self.__id}`);

                        const $this = $(this),
                            $body = $(document.body),
                            bsModal = $this.data('bs.modal');

                        fp.Component.destroyChildComponents(true, $this, true);

                        $this.find('.fp-notification').hide();
                        if(!option.persist) $this.remove();

                        if (!option.container.find('.modal[data-aria-hidden="false"]').length) {
                            $body.removeClass('fp-modal-open');
                            $(document).off('focusin.bs.modal keydown.bs.modal keyup.bs.modal');
                            $body.css('padding-right', '');
                        }

                        fpUi.unpauseLoading();

                        let $activeElement = $(bsModal.activeElement).filter(':visible');
                        if(!$activeElement.length) $activeElement = $body;
                        $activeElement.trigger('focus');
                        delete bsModal.activeElement;
                    })
                    .on('click.closeModal.core', '[data-action="close"], [data-action="cancel"]', function(event) {
                        event.preventDefault();
                        fpUi.hideModal($self);
                    });
            }
        }

        return $modal.call(this, option, relatedTarget);
    };

    $.extend($modal.Constructor.prototype, {
        enforceFocus: function () {
            var self = this;
            $(document)
                .off('focusin.bs.modal') // guard against infinite focus loop
                .on('focusin.bs.modal', function (event) {
                    if (self.$element[0] !== event.target && !self.$element.has(event.target).length) {
                        const $focusElement = self.$element.focusable();
                        ($focusElement.length ? $focusElement : self.$element).trigger('focus');
                    }
                });
        },
        focus: function () {
            if(this.$element[0] !== document.activeElement) this.$element.trigger('focus');
        }
    });

    //ensure backdrop is always inserted before associated modal
    const backdrop = $modal.Constructor.prototype.backdrop;
    $modal.Constructor.prototype.backdrop = function (callback) {
        const self = this;
        callback = _.wrap(callback, function(callback) {
            if(self.$backdrop?.parent().length && self.$element?.parent().length && self.$element.prev()[0] !== self.$backdrop[0]) {
                self.$backdrop.insertBefore(self.$element);
            }
            return callback();
        });
        backdrop.call(this, callback);
    };

    var $tooltip = $.fn.tooltip,
        Tooltip = $tooltip.Constructor,
        tooltipGetCalculatedOffset = Tooltip.prototype.getCalculatedOffset,
        tooltipShow = Tooltip.prototype.show,
        tooltipHide = Tooltip.prototype.hide;

    Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
        if(delta) {
            var offset = (50 * (1 - delta / dimension));
            if(position == 'top') {
                if(offset < 6.32) offset = 6.32;
                else if(offset > 93.57) offset = 93.57;
            }
        }
        this.arrow().css(position, delta ? (offset + '%') : '')
    };

    Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
        var offset = tooltipGetCalculatedOffset.call(this, placement, pos, actualWidth, actualHeight),
            viewportDimensions = this.getPosition(this.$viewport),
            $tip = this.tip();

        if(placement == 'left' || placement == 'right') {
            var marginLeft = Math.abs(fpUtil.getInteger($tip.css('margin-left'))) * 2;
            if (placement == 'left') {
                if(offset.left < marginLeft) {
                    offset.left = marginLeft;
                }
            }
            else if (placement == 'right') {
                var maxLeft = viewportDimensions.width - actualWidth - marginLeft;
                if(offset.left > maxLeft) {
                    offset.left = maxLeft;
                }
            }
        }
        else if(placement == 'top' || placement == 'bottom') {
            var marginTop = Math.abs(fpUtil.getInteger($tip.css('margin-top'))) * 2;
            if (placement == 'top') {
                var minTop = viewportDimensions.scroll + marginTop;
                if(offset.top < minTop) {
                    offset.top = minTop;
                }
            }
            else if (placement == 'bottom') {
                var maxTop = viewportDimensions.height + viewportDimensions.scroll - actualHeight - marginTop;
                if(offset.top > maxTop) {
                    offset.top = maxTop;
                }
            }
        }

        return offset;
    };

    Tooltip.prototype.show = function () {
        tooltipShow.call(this);
        Tooltip.__isShown = this.tip().hasClass('in') ? this : undefined;
        this.$element.removeAttr('aria-describedby'); // remove attr added by bootstrap
        var tipId = this.getUID(this.type);
        this.$element.attr('id', tipId);
        this.$element.find('.fp-tooltip-trigger').attr('aria-describedby', tipId).attr('aria-expanded', true);
    };

    Tooltip.prototype.hide = function () {
        var value = tooltipHide.call(this);
        if(Tooltip.__isShown == this) {
            Tooltip.__isShown = this.tip().hasClass('in') ? this : undefined;
        }
        this.$element.find('.fp-tooltip-trigger').removeAttr('aria-describedby').attr('aria-expanded', false);
        return value;
    };

    $.fn.tooltip = function(option) {
        if(!this.data('bs.tooltip') && (fpUtil.isNull(option) || _.isObject(option))) {
            option = $.extend({container: fp.__$freshop}, option);
        }

        if(this.length && !Tooltip.__handleBodyClick && option && option.trigger == 'click') {
            Tooltip.__handleBodyClick = true;

            $.when($.ready)
                .done(function() {
                    $(document.body)
                        .on('click', function (event) {
                            if (Tooltip.__isShown && (!Tooltip.__lastClickEvent || Tooltip.__lastClickEvent.timeStamp != event.timeStamp)) {
                                var $target = $(event.target),
                                    isTooltip = S($target.attr('aria-describedby')).startsWith('tooltip'),
                                    $tip = !isTooltip && $target.closest('[role="tooltip"]'),
                                    bsTooltip;

                                if(!isTooltip && $tip.length) {
                                    bsTooltip = $tip.data('bs.tooltip');
                                    if(bsTooltip) {
                                        $target = bsTooltip.$element;
                                        isTooltip = true;
                                    }
                                }
                                fp.__$freshop.find('[role="tooltip"]').each(function () {
                                    //debugger;
                                    bsTooltip = $(this).data('bs.tooltip');
                                    if (bsTooltip && (!isTooltip || (isTooltip && !bsTooltip.$element.is($target)))) {
                                        bsTooltip.hide();
                                    }
                                });
                            }
                            Tooltip.__lastClickEvent = event;
                        });
                });
        }

        return $tooltip.call(this, option);
    };

    var $popover = $.fn.popover,
        Popover = $popover.Constructor;
    Popover.prototype.replaceArrow = Tooltip.prototype.replaceArrow;
    Popover.prototype.getCalculatedOffset = Tooltip.prototype.getCalculatedOffset;

    $.fn.popover = function(option) {
        if(!this.data('bs.popover')) {
            if(fpUtil.isNull(option) || _.isObject(option)) {
                // option = $.extend({container: fp.__$freshop}, option);

                // this does not appear to be needed
                // this
                //     .off('show.bs.popover hide.bs.popover')
                //     .on('show.bs.popover hide.bs.popover', function (event) {
                //         var popover = $this.data('bs.popover');
                //         if(!popover) return;

                //         popover.isShown = (event.type == 'show');
                //     });

                var $this = $popover.call(this, option);

                $this.data('bs.popover').tip()
                    .off('click.dismiss.bs.popover', '[data-dismiss="popover"]')
                    .on('click.dismiss.bs.popover', '[data-dismiss="popover"]', function() {
                        var popover = $this.data('bs.popover');
                        if(!popover) return;

                        popover.hide();
                    });

                if(option && option.clickableContent)  {
                    var popover = $this.data('bs.popover'),
                        $tip = popover.tip(),
                        delay = popover.options.delay || 0,
                        showDelay = delay.show || delay || 0,
                        hideDelay = delay.hide || delay || 0,
                        showTimeout = null,
                        hideTimeout = null;

                    $this.add($tip).hover(function show() {
                        if (hideTimeout) {
                            clearTimeout(hideTimeout);
                            hideTimeout = null;
                        }
                        else if (!$tip.is(':visible')) {
                            showTimeout = setTimeout(function () {
                                popover && popover.show();
                                showTimeout = null;
                            }, showDelay);
                        }
                    }, function hide() {
                        if (showTimeout) {
                            clearTimeout(showTimeout);
                            showTimeout = null;
                        }
                        else if ($tip.is(':visible')) {
                            hideTimeout = setTimeout(function () {
                                popover && popover.hide();
                                hideTimeout = null;
                            }, hideDelay);
                        }
                    });
                }

                return $this;
            }
        }

        return $popover.call(this, option);
    };

    var $mask = $.fn.mask;
    $.fn.mask = function(mask, options) {
        //trim country code from North America phone numbers otherwise mask will not format properly
        if(fpConfig.localePhone.format_input && mask == fpConfig.localePhone.default_format) {
            var countryCode = S(fpConfig.localePhone.default_country_code).trimLeft('+').s,
                $input,
                value;

            if(countryCode == '1') {
                var maskLength = mask.replace(/\D/g, '');
                this.each(function () {
                    $input = $(this);
                    if(!$input.data('mask') && (value = $input.val()) && value.length > maskLength.length) {
                        $input.val(S(value).trimLeft(countryCode));
                    }
                });
            }
        }
        return $mask.call(this, mask, options);
    };

    if(fp.parsley) {
        var parsleyField = fp.parsley.Field;
        parsleyField.prototype._getErrorMessage = function(constraint) {
            var validationRules = fpUi.validation.rules,
                rule = validationRules[constraint.name] || validationRules[constraint.requirements],
                $input = this.$element;

            if(rule) {
                var label = $input.attr('fp-error-label') || $input.attr('placeholder') || $input.prev().text(),
                    ruleMessage = _.result(rule, 'message'),
                    linkedInput = $input.attr('fp-validate-linked-input');

                if(linkedInput) {
                    var $linkedInput = $($input[0].form).find(linkedInput).first();                    

                    if($linkedInput.length) {
                        value = fp.ui.getInputValue($linkedInput);
                        if(value) {
                            label += ' or ' + ($linkedInput.attr('fp-error-label') || $linkedInput.attr('placeholder') || $linkedInput.prev().text());
                        }
                    }                
                } 

                return fpUtil.formatString(ruleMessage, label);        
            }
        };

        var insertErrorWrapper = parsleyField.prototype._insertErrorWrapper;
        parsleyField.prototype._insertErrorWrapper = function () {
            var $input = insertErrorWrapper.call(this),
                $errorsWrapper = this._ui.$errorsWrapper,
                $parent = $errorsWrapper.parent();
            if($parent.prop('nodeName') === 'LABEL') {
                $parent.after($errorsWrapper);
            }
            return $input;
        };
    }
    
    $.fn.affix.Constructor.prototype.destroy = function() {
        this.$target.off('scroll.bs.affix.data-api click.bs.affix.data-api');
        this.$element
            .removeData('bs.affix')
            .css('top', '')
            .removeClass($.fn.affix.Constructor.RESET);
    };

    $.fn.classes = function () {
        var classes = [],
            tempClasses;

        this.each(function () {
            tempClasses = S.getString(this.className).split(/\s+/);
            if(tempClasses.length) classes = classes.concat(tempClasses);
        });

        return classes;
    };

    $.fn.replaceClass = function (pattern, value, add) {
        if(!pattern) return this;

        value = S.getString(value) + ' ';
        add = fpUtil.getBoolean(add, true);

        var $this,
            className,
            isRegExp = _.isRegExp(pattern);

        return this.each(function () {
            $this = $(this);
            className = $this.prop('className');

            if(!add && !className) return;

            if(isRegExp) pattern.lastIndex = 0;

            if(className && className.match(pattern) != null) {
                if(isRegExp) pattern.lastIndex = 0;
                className = S(className).trim().replace(pattern, value).s;
                $this.prop('className', className);
            }
            else if(add) $this.addClass(value);
        });
    };

    $.fn.prependClass = function(newClasses) {
        var $this,
            className;

        return this.each(function() {
            $this = $(this);
            className = $this.prop('className');

            $this
                .removeClass(className)
                .addClass(newClasses + ' ' + className);
        });
    };

    $.fn.toggleAttr = function(attr, value, stateVal) {
        value = S.getString(value);
        if (typeof(stateVal) == 'boolean') {
            return stateVal ? this.attr(attr, value) : this.removeAttr(attr);
        }
        return this.each(function() {
            var $this = $(this);
            $this.attr(attr) ? $this.removeAttr(attr) : $this.attr(attr, value);
        });
    };

    //compares if the (first) element of a jQuery object is before the
    //the (first) element of a passed in jQuery selector
    //
    //Note: invalid selectors will return false
    $.fn.isBefore = function(selector) {
        var $element = $(selector);
        if(!(this.length && $element.length)) return false;

        return (this[0].compareDocumentPosition($element[0]) & 0x04) ? true : false;
    };

    //compares if the (first) element of a jQuery object is after the
    //the (first) element of a passed in jQuery selector
    //
    //Note: invalid selectors will return false
    $.fn.isAfter = function(selector) {
        var $element = $(selector);
        if(!(this.length && $element.length)) return false;

        return (this[0].compareDocumentPosition($element[0]) & 0x02) ? true : false;
    };

    $.fn.attrs = function(suffix, stripSuffix, underscore, camelize) {
        var attrs = {},
            element = this.first()[0];

        if(!element) return attrs;

        if(fpUtil.isNull(stripSuffix)) stripSuffix = suffix;
        else if(!_.isString(stripSuffix)) stripSuffix = stripSuffix ? suffix : stripSuffix;

        var name;
        _.each(element.attributes, function(attr) {
            name = S(attr.name).trim();
            if(suffix) {
                if(!name.startsWith(suffix)) return;
                if(stripSuffix) name = name.trimLeft(stripSuffix);
            }
            if(underscore) name = name.underscore();
            else if(camelize) {
                name = name.replace(/(\-|\s)+(.)?/g, function(mathc, sep, c) {
                    return (c ? c.toUpperCase() : '');
                });
            }
            attrs[name.s] = attr.value;
        });

        return attrs;
    };

    var $param = $.param;
    $.param = function(obj, traditional) {
        traditional = traditional != null ? traditional : undefined;

        if(_.isObject(obj)) {
            if(window.FormData && obj.constructor === FormData.prototype.constructor && _.isFunction(obj.entries)) {
                var entries = obj.entries(),
                    item = entries.next();

                obj = {};

                while (item) {
                    if (fpUtil.isDefined(item.value)) {
                        if(item.value[1] instanceof File) obj[item.value[0]] = _.uniqueId('file_') + item.value[1].name;
                        else obj[item.value[0]] = S.getString(item.value[1]);
                    }

                    if (item.done) break;
                    item = entries.next();
                }
            }
        }

        if (_.size(obj)) {
            var tempArray = [];
            _.each(fpUtil.sort(_.keys(obj)), function (key) {
                //don't add undefined values
                if (!fpUtil.isDefined(obj[key])) return;
                tempArray.push({name: key, value: obj[key]});
            });

            obj = tempArray;
        }

        return $param(obj, traditional);
    };

    //override $.Deferred so that a deferred function can be added to each promise
    var $Deferred = $.Deferred;
    $.Deferred = function(func) {
        var deferred = $Deferred.apply($, arguments),
            funcPromise = deferred.promise,
            funcDeferred = function() {
                return deferred;
            };

        deferred.promise = function(obj) {
            var promise = funcPromise.apply(deferred, arguments);
            promise.deferred = funcDeferred;

            return promise;
        };

        return deferred;
    };

    $.Deferred.exceptionHook = function(exc, stack) {
        if(exc instanceof Error && !exc.__processed) {
            exc.__processed = true;
            //delay to allow meta data to be added to exception
            _.delay(function() {
                fp.notifier.notify(exc);
            }, 10);
        }
    };

    //override $.when to ensure all promises resolve before always is triggered (first error would typically prevent this from happening)
    //https://gist.github.com/fearphage/4341799

    function adoptValue( value, resolve, reject ) {
        var method;

        try {

            // Check for promise aspect first to privilege synchronous behavior
            if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
                method.call( value ).done( resolve ).fail( reject );

                // Other thenables
            } else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
                method.call( value, resolve, reject );

                // Other non-thenables
            } else {

                // Support: Android 4.0 only
                // Strict mode functions invoked without .call/.apply get global-object context
                resolve.call( undefined, value );
            }

            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
        } catch ( value ) {

            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.call( undefined, value );
        }
    }

    $.when = function( singleValue ) {
        if(!arguments.length) return $.Deferred().resolve().promise();
        if(arguments.length == 1 && fpUtil.isPromise(singleValue)) {
            return singleValue.promise();
        }

        var

        // count of uncompleted subordinates
            remaining = arguments.length,

        // count of unprocessed arguments
            i = remaining,

        // subordinate fulfillment data
            resolveContexts = Array( i ),
            resolveValues = _.toArray(arguments),

        // the master Deferred
            master = jQuery.Deferred(),

        // subordinate callback factory
            updateFunc = function( i ) {
                return function( value ) {
                    resolveContexts[ i ] = this;
                    resolveValues[ i ] = arguments.length > 1 ? _.toArray(arguments) : value;
                    if ( !( --remaining ) ) {
                        master.resolveWith( resolveContexts, resolveValues );
                    }
                };
            },
            rejectUpdateFunc = function( i ) {
                return function( value ) {
                    resolveContexts[ i ] = this;
                    resolveValues[ i ] = arguments.length > 1 ? _.toArray(arguments) : value;

                    if(value instanceof Error) $.Deferred.exceptionHook(value);

                    if ( !( --remaining ) ) {
                        master.rejectWith( resolveContexts, resolveValues );
                    }
                };
            };

        // Single- and empty arguments are adopted like Promise.resolve
        if ( remaining <= 1 ) {
            adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.fail(rejectUpdateFunc(i, resolveContexts, resolveValues)).reject);

            // Use .then() to unwrap secondary thenables (cf. gh-3000)
            if ( master.state() === "pending" ||
                jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

                return master.then();
            }
        }

        // Multiple arguments are aggregated like Promise.all array elements
        while ( i-- ) {
            adoptValue(resolveValues[ i ], updateFunc(i, resolveContexts, resolveValues), rejectUpdateFunc(i, resolveContexts, resolveValues));
        }


        return master.promise();
    };

    $.viewport = function () {
        var doc = document.documentElement,
            scrollTop = doc.scrollTop || document.body.scrollTop,
            scrollLeft = doc.scrollLeft || document.body.scrollLeft;

        return {
            left: scrollLeft,
            right: doc.clientWidth + scrollLeft,
            top: scrollTop,
            bottom: doc.clientHeight + scrollTop,
            width: doc.clientWidth,
            height: doc.clientHeight
        };
    };

    $.isInViewport = function($element) {
        const viewport = $.viewport(),
            offset = $($element).offset() || {};
        //check if element is visible in viewport
        return fpUtil.getBoolean((offset.top >= viewport.top && offset.top <= viewport.bottom) &&
            (offset.left >= viewport.left && offset.left <= viewport.right));
    };

    $.scrollbarWidth = function () {
        var $scrollDiv = $('<div></div>')
            .css({
                height: '100px',
                overflow: 'scroll',
                position: 'absolute',
                top: '-9999px'
            }).
            appendTo(document.body),
            scrollDiv = $scrollDiv[0],
            width = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        $scrollDiv.remove();

        return width;
    };

    $.fn.toggleAttr = function(attr, attr1, attr2) {
        return this.each(function() {
            var self = $(this);
            if (self.attr(attr) == attr1)
                self.attr(attr, attr2);
            else
                self.attr(attr, attr1);
        });
    };

    var generate = fpUi.generateFreshopPlugin;
    generate('category', ui.Category, 'fp.ui.Category');
    generate('dropdown', ui.Dropdown, 'fp.ui.Dropdown');
	generate('pager', ui.Pager, 'fp.ui.Pager');
    generate('resultHeader', ui.ResultHeader, 'fp.ui.ResultHeader');
})();
